/**
 * 导航栏相关action
 */
 import oData from '../server/odata_client';
 import Store from '../script/store';
 import Sockette from 'sockette';

export const SET_CUR_ONENODE = 'SET_CUR_ONENODE'    //设置当前一级菜单
export const SET_CUR_TWONODE1 = 'SET_CUR_TWONODE1'    //设置当前二级菜单
export const SET_CUR_TWONODE2 = 'SET_CUR_TWONODE2'    //设置当前二级菜单
export const SET_CUR_TWONODE3 = 'SET_CUR_TWONODE3'    //设置当前二级菜单
export const SET_CUR_TWONODE4 = 'SET_CUR_TWONODE4'    //设置当前二级菜单
export const SET_CUR_TWONODE5 = 'SET_CUR_TWONODE5'    //设置当前二级菜单
export const SET_CUR_TWONODE6 = 'SET_CUR_TWONODE6'    //设置当前二级菜单
export const SET_CUR_TWONODE7 = 'SET_CUR_TWONODE7'    //设置当前二级菜单
export const SET_CUR_TWONODE8 = 'SET_CUR_TWONODE8'    //设置当前二级菜单
export const SET_PRE_TWONODE1 = 'SET_PRE_TWONODE1'    //设置之前二级菜单
export const SET_PRE_TWONODE2 = 'SET_PRE_TWONODE2'    //设置之前二级菜单
export const SET_PRE_TWONODE3 = 'SET_PRE_TWONODE3'    //设置之前二级菜单
export const SET_PRE_TWONODE4 = 'SET_PRE_TWONODE4'    //设置之前二级菜单
export const SET_PRE_TWONODE5 = 'SET_PRE_TWONODE5'    //设置之前二级菜单
export const SET_PRE_TWONODE6 = 'SET_PRE_TWONODE6'    //设置之前二级菜单
export const SET_PRE_TWONODE7 = 'SET_PRE_TWONODE7'    //设置之前二级菜单
export const SET_PRE_TWONODE8 = 'SET_PRE_TWONODE8'    //设置之前二级菜单
export const SET_CUR_THREENODE = 'SET_CUR_THREENODE'  //设置当前三级菜单
export const SET_PRE_THREENODE = 'SET_PRE_THREENODE'  //设置之前三级菜单
export const SET_CURNAME='SET_CURNAME'


export const SET_INITTREEONE='SET_INITTREEONE' //deeplog 设置当前一级菜单节点
export const SET_INITTREETWO='SET_INITTREETWO' //deeplog 设置当前二级菜单节点
export const SET_MONITORCOUNT = 'SET_MONITORCOUNT' //获取检测器总数
export const SET_ONLINEUSERCOUNT = 'SET_ONLINEUSERCOUNT'; //设置在线用户数

let ws = null;

export function setCurName(curName){
  return {
    type: SET_CURNAME,
    curName
  }
}

export function setOnlineUserCount(onlineUserCount) {
  return {
    type: SET_ONLINEUSERCOUNT,
    onlineUserCount
  }
}

export function setInitTreeOne(curNode) {
  return {
    type: SET_INITTREEONE,
    curNode
  }
}
export function setInitTreeTwo(curNode) {
  return {
    type: SET_INITTREETWO,
    curNode
  }
}

export function setCurOneNode(curNode) {
  return {
    type: SET_CUR_ONENODE,
    curNode
  }
}

export function setCurThreeNode(curNode){
  return {
    type: SET_CUR_THREENODE,
    curNode
  }
}

export function setPreThreeNode(curNode){
  return {
    type: SET_PRE_THREENODE,
    curNode
  }
}

export function setMonitorCount(monitorCount){
  return {
    type: SET_MONITORCOUNT,
    monitorCount
  }
}

export function setCurTwoNode(param) {
  var treeId = param[0];
  var curNode = param[1];
  switch (treeId) {
    case "indexMenu":
      return {
        type: SET_CUR_TWONODE1,
        curNode
      }
      break;
    case "resourceMenu":
      return {
        type: SET_CUR_TWONODE2,
        curNode
      }
      break;
    case "assetMenu":
      return {
        type: SET_CUR_TWONODE3,
        curNode
      }
      break;
    case "mapMenu":
      return {
        type: SET_CUR_TWONODE4,
        curNode
      }
      break;
    case "workOrderMenu":
      return {
        type: SET_CUR_TWONODE5,
        curNode
      }
      break;
    case "reportMenu":
      return {
        type: SET_CUR_TWONODE6,
        curNode
      }
      break;
    case "systemMenu":
      return {
        type: SET_CUR_TWONODE7,
        curNode
      }
      break;
    case "deepLogMenu":
      return {
        type: SET_CUR_TWONODE8,
        curNode
      }
      break;
  };
}

export function setPreTwoNode(param) {
  var treeId = param[0];
  var curNode = param[1];
  switch (treeId) {
    case "indexMenu":
      return {
        type: SET_PRE_TWONODE1,
        curNode
      }
      break;
    case "resourceMenu":
      return {
        type: SET_PRE_TWONODE2,
        curNode
      }
      break;
    case "assetMenu":
      return {
        type: SET_PRE_TWONODE3,
        curNode
      }
      break;
    case "mapMenu":
      return {
        type: SET_PRE_TWONODE4,
        curNode
      }
      break;
    case "workOrderMenu":
      return {
        type: SET_PRE_TWONODE5,
        curNode
      }
      break;
    case "reportMenu":
      return {
        type: SET_PRE_TWONODE6,
        curNode
      }
      break;
    case "systemMenu":
      return {
        type: SET_PRE_TWONODE7,
        curNode
      }
      break;
    case "deepLogMenu":
      return {
        type: SET_PRE_TWONODE8,
        curNode
      }
      break;
  };
}

//获取检测器总数
export function getMonitorCount(callback) {
  return dispatch => {
    oData.getMonitorCount(function(data) {
      dispatch(setMonitorCount(data));
      callback && callback(data);
    }, function(status) {
      dispatch(setMonitorCount([]));
      callback && callback();
    });
  }
}

//建立websocket连接
export function initWebSocket() {
  return (dispatch) => {
    let wsUrl = '';
    if (Store.get('wsUrl').indexOf('ws') == 0) {
      wsUrl = Store.get('wsUrl');
    } else {
      const protocol = location.protocol;
      const prefix = protocol == 'https:' ? 'wss://' : 'ws://';
      wsUrl = prefix + location.hostname + (location.port ? ':' + location.port : '') + Store.get('wsUrl');
    }
    ws = new Sockette(wsUrl, {
      timeout: 5e3,
      maxAttempts: 10,
      onopen: e => {/*console.log('Connected!', e)*/},
      onmessage: e => dispatch(onMessageHandler(e)),
      onreconnect: e => {/*console.log('Reconnecting...', e)*/},
      onmaximum: e => {/*console.log('Stop Attempting!', e)*/},
      onclose: e => {/*console.log('Closed!', e)*/},
      onerror: e => {/*console.log('Error:', e)*/}
    });
  }
}

//发送websocket消息
export function sendWebSocketMessage(message) {
  return dispatch => {
    if (ws) {
      ws.send(message);
    } else {
      console.log('No available websocket connection.');
    }
  }
}

//关闭websocket连接
export function closeWebSocket(){
  return dispatch => {
    if (ws) {
      ws.close();
    }
  }
}

//服务器推送消息处理
function onMessageHandler(e) {
  return (dispatch, getState) => {
    let data = JSON.parse(e.data);
    let state = getState();
    if (data.hasOwnProperty('UserOnline')) {  //在线用户数
      let count = parseInt(data.UserOnline);
      if (state.navbarReducer.onlineUserCount != count) {
        dispatch(setOnlineUserCount(count));
      }
    } else if(data.hasOwnProperty('MonitorInfo')){ //正在运行监测器数
      let monitorCount = data.MonitorInfo.running + ' / ' + data.MonitorInfo.total;
      if (state.navbarReducer.monitorCount != monitorCount) {
        dispatch(setMonitorCount(monitorCount));
      }
    } else {
      // console.log(data);
      if (data.hasOwnProperty('boname')) {

      }
    }
  }
}
